module.exports = __webpack_public_path__ + "static/media/lima bean.1d38d7a2.png";